var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicensePlate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 12,
    viewBox: "0 0 38 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6501 10.6923H2.34981C1.60438 10.6923 1 10.0711 1 9.30474V2.38757C1 1.62128 1.60438 1 2.34981 1H35.6501C36.3956 1 37 1.62128 37 2.38757V9.30474C37 10.0711 36.3956 10.6923 35.6501 10.6923Z",
    stroke: "#193232",
    strokeWidth: 1.03846,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6922 6.88492C19.6922 7.45842 19.2272 7.92338 18.6537 7.92338C18.0801 7.92338 17.6152 7.45842 17.6152 6.88492V4.80799C17.6152 4.23449 18.0801 3.76953 18.6537 3.76953C19.2272 3.76953 19.6922 4.23449 19.6922 4.80799V6.88492Z",
    stroke: "#193232",
    strokeWidth: 0.692308,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0008 6.88492C28.0008 7.45842 27.5358 7.92338 26.9623 7.92338C26.3887 7.92338 25.9238 7.45842 25.9238 6.88492V4.80799C25.9238 4.23449 26.3887 3.76953 26.9623 3.76953C27.5358 3.76953 28.0008 4.23449 28.0008 4.80799V6.88492Z",
    stroke: "#193232",
    strokeWidth: 0.692308,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2312 4.80799C34.2312 5.3815 33.7663 5.84645 33.1928 5.84645C32.6192 5.84645 32.1543 5.3815 32.1543 4.80799C32.1543 4.23449 32.6192 3.76953 33.1928 3.76953C33.7663 3.76953 34.2312 4.23449 34.2312 4.80799Z",
    stroke: "#193232",
    strokeWidth: 0.692308,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2312 6.88612C34.2312 7.45963 33.7663 7.92458 33.1928 7.92458C32.6192 7.92458 32.1543 7.45963 32.1543 6.88612C32.1543 6.31261 32.6192 5.84766 33.1928 5.84766C33.7663 5.84766 34.2312 6.31261 34.2312 6.88612Z",
    stroke: "#193232",
    strokeWidth: 0.692308,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1088 4.54841C21.2241 4.10054 21.6307 3.76953 22.1146 3.76953C22.6881 3.76953 23.1531 4.23457 23.1531 4.80806C23.1531 5.38156 22.6881 5.8465 22.1146 5.8465C21.541 5.8465 21.0762 6.31145 21.0762 6.88485V7.92338H23.1531",
    stroke: "#193232",
    strokeWidth: 0.692308,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.808 5.84645C14.3815 5.84645 14.8465 6.31141 14.8465 6.88492C14.8465 7.45842 14.3815 7.92338 13.808 7.92338H12.7695V3.76953H13.808C14.3815 3.76953 14.8465 4.23449 14.8465 4.80799C14.8465 5.3815 14.3815 5.84645 13.808 5.84645H12.7695",
    stroke: "#193232",
    strokeWidth: 0.692308,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3471 5.84645C10.9206 5.84645 11.3855 6.31141 11.3855 6.88492C11.3855 7.45842 10.9206 7.92338 10.3471 7.92338H9.30859V3.76953H10.3471C10.9206 3.76953 11.3855 4.23449 11.3855 4.80799C11.3855 5.3815 10.9206 5.84645 10.3471 5.84645H9.30859",
    stroke: "#193232",
    strokeWidth: 0.692308,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3848 4.54841L30.0771 3.76953V7.83414",
    stroke: "#193232",
    strokeWidth: 0.692308,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3398 7.85547H30.947",
    stroke: "#193232",
    strokeWidth: 0.692308,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14258 1V10.4286",
    stroke: "#193232",
    strokeWidth: 0.692308,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensePlate);
export default __webpack_public_path__ + "static/media/license-plate.347d8a7d26adfba710a214da86546915.svg";
export { ForwardRef as ReactComponent };